import { bl_mrp_container_size_RowClass } from '../../dbschema';
import { BaseContainerModel } from '../base-container.model';

export class MrpContainerSizeContainer extends BaseContainerModel {
  bl_mrp_container_size: bl_mrp_container_size_RowClass = new bl_mrp_container_size_RowClass();
}